import { connect } from 'react-redux';
import React, { Component } from 'react';
import {Router, Route, IndexRoute, browserHistory} from 'react-router';

import App from './App';
import ApiViewer from './ApiViewer';
import RouteDetails from './RouteDetails';

import config from '../../config/default.js';
const prefix = config.prefix || '/';

const generate_routes = (key, spec) => {
  if (!spec) return null;
  return [
    <Route path={key} component={RouteDetails}/>
  ].concat(
    Object.keys(spec)
      .filter(key => key.startsWith('/'))
      .map(_key => generate_routes(key + _key, spec[_key]))
  );
};

const generate_api = (name, spec) =>
  <Route key={name} path={name} component={ApiViewer}>
    <IndexRoute component={RouteDetails}/>
    {Object.keys(spec.routes)
      .filter(key => key.startsWith('/'))
      .map(key => generate_routes(name + key, spec.routes[key]))}
  </Route>;

class AppRouter extends Component {
  render() {
    return (
      <Router history={browserHistory}>
        <Route path={prefix} component={App}>
          <IndexRoute component={ApiViewer}/>
          <Route component={ApiViewer}>
            <Route path='*' component={RouteDetails}/>
          </Route>
        </Route>
      </Router>
    );
  }
}

export default AppRouter;
